export class CreatePaymentPlanRequest {
  constructor(
    public debtorId: string,
    public quote: string,
    public financedAmount: number,
    public initialAmount: number,
    public numberOfSequences: number,
    public numberOfSessions: number,
    public secured: boolean
  ) {}
}
